export const COLLECTION_SORT_KEYS = [
    {
        shopifyKey: 'RELEVANCE',
        reverse: false,
        displayTranslate: 'RELEVANCE',
        id: 'RELEVANCE',
    },
    {
        shopifyKey: 'BEST_SELLING',
        reverse: false,
        displayTranslate: 'BEST_SELLING',
        id: 'BEST_SELLING',
    },
    {
        shopifyKey: 'CREATED',
        reverse: false,
        displayTranslate: 'CREATED_NEW',
        id: 'CREATED_NEW',
    },
    {
        shopifyKey: 'CREATED',
        reverse: true,
        displayTranslate: 'CREATED_OLD',
        id: 'CREATED_OLD',
    },
    {
        shopifyKey: 'PRICE',
        reverse: false,
        displayTranslate: 'PRICE_LOW',
        id: 'PRICE_LOW',
    },
    {
        shopifyKey: 'PRICE',
        reverse: true,
        displayTranslate: 'PRICE_HIGH',
        id: 'PRICE_HIGH',
    },
    {
        shopifyKey: 'TITLE',
        reverse: false,
        displayTranslate: 'TITLE_AZ',
        id: 'TITLE_AZ',
    },
    {
        shopifyKey: 'TITLE',
        reverse: true,
        displayTranslate: 'TITLE_ZA',
        id: 'TITLE_ZA',
    }
];
